module.exports = __webpack_public_path__ + "img/kosciol2.a4ae7189.jpg";